import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "flex justify-center" };
import BlockViewer from "@/components/uikit/platformComponents/blockEditor/BlockViewer.vue";
import { computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ItParkShowPage',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const itPark = computed(() => store.getters["itPark/itPark"]);
        const parkName = computed(() => itPark.value?.name);
        const blocks = computed(() => {
            if (!itPark.value?.description) {
                return [];
            }
            try {
                return JSON.parse(itPark.value.description);
            }
            catch (e) {
                console.error("Failed to parse blocks", e);
                return [];
            }
        });
        const dataLoading = computed(() => store.getters["itPark/dataLoading"]);
        onMounted(async () => {
            const itParkId = router.currentRoute.value.params.id;
            if (itParkId) {
                await store.dispatch("itPark/getItPark", itParkId);
            }
        });
        const breadcrumbItems = computed(() => [
            { label: "Dashboard", route: "/" },
            { label: "IT-Parks", route: "/it-parks" },
            { label: parkName.value || "IT-Park" }
        ]);
        return (_ctx, _cache) => {
            const _component_UBreadcrumbs = _resolveComponent("UBreadcrumbs");
            const _component_UProgressBar = _resolveComponent("UProgressBar");
            const _component_UContent = _resolveComponent("UContent");
            const _component_UList = _resolveComponent("UList");
            return (_openBlock(), _createBlock(_component_UList, null, {
                default: _withCtx(() => [
                    _createVNode(_component_UBreadcrumbs, { items: breadcrumbItems.value }, null, 8, ["items"]),
                    (dataLoading.value)
                        ? (_openBlock(), _createBlock(_component_UProgressBar, {
                            key: 0,
                            green: "",
                            "is-loader": ""
                        }))
                        : (itPark.value)
                            ? (_openBlock(), _createBlock(_component_UContent, { key: 1 }, {
                                header: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(parkName.value), 1)
                                ]),
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_1, [
                                        _createVNode(BlockViewer, {
                                            class: "w-[900px]",
                                            blocks: blocks.value
                                        }, null, 8, ["blocks"])
                                    ])
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
